var createReactClass = require('create-react-class');
import axios from 'axios';
import { connect } from "react-redux";

const qs = require('qs');

var API = createReactClass({
    statics: {
        CUST: {
            Coupon:{
                LookUp:function(PostData) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/coupon/lookup?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                },
                Apply:function(PostData) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/coupon/apply?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                },
            },
            Order: {
                Get: function(PostData) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/order/get?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                },
                Set:function(PostData) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/order/set?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                }
            },
            Customer:{
                Set:function(PostData){
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/customer/set?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                }
            },
            Address:{
                Add: function(PostData){
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/address/add?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                },
                Deactive: function(PostData){
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'post',
                            url: 'https://hub.akschap.com/api/cust/address/deactive?time=' + Date.now(),
                            data: qs.stringify({ data: PostData })
                        })
                            .then(res => {
                                return resolve(res.data.data);
                            }).catch(function (error) {
                                return reject(error);
                            });
                    });
                }
            }
        }
    },

    render: function () { return; }
});


export default connect()(API);